import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_SURVEY_TEMPLATE_QUESTION_ITEMS,
  GET_SURVEY_TEMPLATE_QUESTION_ITEMS,
  SG_FETCH_SURVEY_TEMPLATE_QUESTION_ITEM,
  FETCH_SURVEY_TEMPLATE_QUESTION_ITEM,
  SG_ADD_SURVEY_TEMPLATE_QUESTION_ITEM,
  ADD_SURVEY_TEMPLATE_QUESTION_ITEM,
  SG_UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM,
  UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM,
  SG_DELETE_SURVEY_TEMPLATE_QUESTION_ITEM,
  DELETE_SURVEY_TEMPLATE_QUESTION_ITEM,
  SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getSurveyTemplateQuestionItems(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING });
    const response = yield call(api.GET_SURVEY_TEMPLATE_QUESTION_ITEMS, action.payload);
    yield put({ type: GET_SURVEY_TEMPLATE_QUESTION_ITEMS, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchSurveyTemplateQuestionItem(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING });
    const response = yield call(api.FETCH_SURVEY_TEMPLATE_QUESTION_ITEM, action.payload);
    yield put({ type: FETCH_SURVEY_TEMPLATE_QUESTION_ITEM, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addSurveyTemplateQuestionItem(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING });
    const response = yield call(api.ADD_SURVEY_TEMPLATE_QUESTION_ITEM, action.payload);
    yield put({ type: ADD_SURVEY_TEMPLATE_QUESTION_ITEM, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateSurveyTemplateQuestionItem(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING });
    const response = yield call(api.UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM, action.payload);
    yield put({ type: UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteSurveyTemplateQuestionItem(action) {
  try {
    yield put({ type: SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING });
    yield call(api.DELETE_SURVEY_TEMPLATE_QUESTION_ITEM, action.payload);
    yield put({ type: DELETE_SURVEY_TEMPLATE_QUESTION_ITEM, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* surveyTemplateQuestionItemsSaga() {
  yield takeLatest(SG_GET_SURVEY_TEMPLATE_QUESTION_ITEMS, getSurveyTemplateQuestionItems);
  yield takeLatest(SG_FETCH_SURVEY_TEMPLATE_QUESTION_ITEM, fetchSurveyTemplateQuestionItem);
  yield takeLatest(SG_ADD_SURVEY_TEMPLATE_QUESTION_ITEM, addSurveyTemplateQuestionItem);
  yield takeLatest(SG_UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM, updateSurveyTemplateQuestionItem);
  yield takeLatest(SG_DELETE_SURVEY_TEMPLATE_QUESTION_ITEM, deleteSurveyTemplateQuestionItem);
}